import React from "react";

export default function AttachmentPanel() {

  return (

    <div className="card mb-4">

      <div className="card-body">

        Attachments

      </div>

    </div>

  );

}